const Common = ["Sale", "serviceCount", "percent"];

const TOFriendOrFoeByPeriodByCarFamily = [
  "Sale",
  "serviceCountGeneral",
  "percentGeneral",
  "serviceCountMine",
  "percentMine",
  "serviceCountStranger",
  "percentStranger",
];

const warrantyRepairBySalesPeriod = [
  "Sale",
  "serviceCountGeneral",
  "percentGeneral",
  "serviceCountMine",
  "percentMine",
  "serviceCountStranger",
  "percentStranger",
];

const ReportReturnCarServiceDynamics = [
  "countCarService",
  "countCarServicePercent",
];

const ReportReturnCarAverageDailyMileageByMonth = [
  "countCar",
  "averageDay",
  "mileage",
  "AverageDailyMileage",
];

const ReportReturnCarServiceByDealer = ["AllTO", "Warranty", "writ"];
const ReportReturnClientsWithoutService = [
  "countCar",
  "withoutServices",
  "percent",
];
const ReportReturnSRR3ForPayments = [
  "target",
  "countSale",
  "countService",
  "percent",
  "percentTarget",
];
const InvitationOfClientsForMaintenance = [];
const ReportReturnSRR3ByCar = ["countSale", "countService", "percent"];
const ReportReturnSRRByVIN = ["dealerName", "dateVisit"];
const ReportReturnSRR5ForPayments = [
  "target",
  "countSale",
  "countService",
  "percent",
  "percentTarget",
];
const GIBDD = [
  "Sale",
  "countRegisteredCity",
  "countRegisteredRegion",
  // "countRegisteredAllRegion",
  "serviceCount",
  "percentSale",
  "percentSaleCity",
  "percentSaleRegion",
  "percentSaleAllRegion",
];
const GIBDDForeign = [
  "Sale",
  "countRegisteredCity",
  "countRegisteredRegion",
  // "countRegisteredAllRegion",
  "serviceCount",
  "percentSale",
  "percentSaleCity",
  "percentSaleRegion",
  "percentSaleAllRegion",
  "serviceCountMine",
  "percentMine",
  "serviceCountStranger",
  "percentStranger",
];

const GIBDDDealer = [
  "Sale",
  "countRegisteredCity",
  "countRegisteredRegion",
  "serviceCount",
  "percentSale",
  "percentSaleCity",
  "percentSaleRegion",
];

const TOReturnCarForServiceByPeriodConsolidated = [
  "nameDealer",
  "inn",
  "dateVisit",
  "countDay",
];
const ReportReturnUniqueService = [
  "1stYear",
  "2ndYear",
  "3rdYear",
  "4thYear",
  "5thYear",
  "6thYear",
  "7thYear",
  "8thYear",
  "9thYear",
  "10thYear",
];
const ReportReturnLoyaltyServiceByDealer = [];

export const getNameColumnChildren = (test: string, arrTO: string[]) => {
  switch (test) {
    // case "TOMonthOfControlCarFamilyRegion":

    // case "ReportReturnSRR3ByDealer":
    case "ReportReturnSRR3ByPeriod":
    // case "ReportReturnSRR5ByDealer":
    case "ReportReturnSRR5ByPeriod":
      return Common;

    // case "TOFriendOrFoeByPeriodByCarFamily":
    //   return TOFriendOrFoeByPeriodByCarFamily;
    // case "warrantyRepairBySalesPeriod":
    //   return warrantyRepairBySalesPeriod;
    case "ReportReturnCarServiceDynamics":
      return ReportReturnCarServiceDynamics;
    // case "ReportReturnCarServiceByDealer":
    //   return [...arrTO, ...ReportReturnCarServiceByDealer];
    case "ReportReturnCarAverageDailyMileageByMonth":
      return ReportReturnCarAverageDailyMileageByMonth;
    case "ReportReturnClientsWithoutService":
      return ReportReturnClientsWithoutService;
    // case "ReportReturnSRR3ForPayments":
    //   return ReportReturnSRR3ForPayments;
    case "ReportReturnUniqueService":
      return ReportReturnUniqueService;
    case "ReportReturnLoyaltyServiceByDealer":
    case "ReportNSByDealer":
    case "ReportNSByClient":
    case "ReportNSByWarmClients":
    case "ReportNSByOldClients":
    case "ReportNSByAverageCarAge":
    case "ReportNSByClientCarSale":
    case "TOMonthOfControlMine":
    case "TOOwnBySalesPeriod":
    case "warrantyRepairMonthOfControl":
    case "TOMonthOfControlFriendOrFoe":
    case "TOMonthOfControlFriendOrFoeByCarFamily":
    case "TOFriendOrFoeBySalesPeriod":
    case "TOFriendOrFoeByPeriodByCarFamily":
    case "warrantyRepairBySalesPeriod":
    case "TOMonthOfControlCarFamilyRegion":
    case "ReportReturnCarServiceByDealer":
    case "ReportReturnSRR3ForPayments":
    case "ReportReturnSRR5ForPayments":
    case "ReportReturnSRR3ByDealer":
    case "ReportReturnSRR5ByDealer":
    case "ReportReturnSRR3ByCar":
    case "ReportReturnSRR5ByCar":
      return ReportReturnLoyaltyServiceByDealer;
    case "InvitationOfClientsForMaintenance":
      return InvitationOfClientsForMaintenance;
    // case "ReportReturnSRR3ByCar":
    // case "ReportReturnSRR5ByCar":
    //   return ReportReturnSRR3ByCar;
    case "ReportReturnSRR3ByVIN":
    case "ReportReturnSRR5ByVIN":
      return ReportReturnSRRByVIN;
    case "ReportReturnCarForServiceGIBDDByMonth":
    case "ReportReturnCarForServiceGIBDDByPeriod":
    case "ReportReturnSRR5GIBDDByPeriod":
    case "ReportReturnSRR3GIBDDByPeriod":
      return GIBDD;
    case "ReportReturnCarForeignForServiceGIBDDByMonth":
    case "ReportReturnCarForeignForServiceGIBDDByPeriod":
      return GIBDDForeign;
    case "ReportReturnSRR3GIBDDByDealer":
    case "ReportReturnSRR5GIBDDByDealer":
      return GIBDDDealer;

    // case "ReportReturnSRR5ForPayments":
    //   return ReportReturnSRR5ForPayments;
    case "TOReturnCarForServiceByPeriodConsolidated":
      return TOReturnCarForServiceByPeriodConsolidated;
  }
};
